<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m13.2 2 .7.1.2.1.4.5v.1l.1.1q.2.5 0 .8L13 9.3h6.3a2 2 0 0 1 1.6 1.1 2 2 0 0 1-.3 2l-8.9 9.3a1.3 1.3 0 0 1-2.2-.4v-1l1.7-5.4H4.8a2 2 0 0 1-1.6-1.1 2 2 0 0 1 .2-2l9-9.3zM4.8 13h6.3a2 2 0 0 1 1.5.7 2 2 0 0 1 .2 1.6L11.7 19l7.5-7.8h-6.3a2 2 0 0 1-1.5-.8 2 2 0 0 1-.2-1.6L12.3 5z"
    />
  </svg>
</template>
